import { Link } from 'react-router-dom';

const friendLinks = [
  { label: '国家电影局', href: 'https://www.chinafilm.gov.cn' },
  { label: '中国电影资料馆', href: 'https://www.cfa.org.cn' },
  { label: '电影节展讯', href: 'https://51hlzhan.asia' },
  { label: '影视版权交易', href: 'https://51hlzhan.asia' },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-portal px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-background-950">
                <i className="ri-clapperboard-fill text-lg" />
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-background-50">影视仓</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              影视仓是一个专注于影视内容推荐与资讯聚合的平台。我们整理最新电影、电视剧的推荐与动态，帮助你更快发现值得一看的好内容。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              {['ri-weibo-fill', 'ri-wechat-line', 'ri-bilibili-line', 'ri-youtube-line'].map((icon) => (
                <span
                  key={icon}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-200 transition-colors hover:bg-accent-500 hover:text-background-950"
                >
                  <i className={`${icon} text-base`} />
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li>
                <Link to="/" className="transition-colors hover:text-accent-400">首页</Link>
              </li>
              <li>
                <Link to="/category/电影" className="transition-colors hover:text-accent-400">电影分类</Link>
              </li>
              <li>
                <Link to="/category/电视剧" className="transition-colors hover:text-accent-400">电视剧分类</Link>
              </li>
              <li>
                <Link to="/news" className="transition-colors hover:text-accent-400">影视资讯</Link>
              </li>
              <li>
                <Link to="/search" className="transition-colors hover:text-accent-400">全站搜索</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-50">友情链接</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              {friendLinks.map((link) => (
                <li key={link.label}>
                  <a href={link.href} target="_blank" rel="noreferrer" className="transition-colors hover:text-accent-400">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-50/10 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 影视仓 版权所有 · 本站内容为演示示例，仅供学习交流</p>
          <p className="flex flex-wrap gap-4">
            <span className="cursor-pointer transition-colors hover:text-accent-400">用户协议</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">隐私政策</span>
            <span className="cursor-pointer transition-colors hover:text-accent-400">联系合作</span>
          </p>
        </div>
      </div>
    </footer>
  );
}